import TaleCategory from '../../../model/domain/tale-category'

export const ROUTE_ID = '/tales/:category'
export const ROUTE_TEMPLATE = (category: TaleCategory) => `/tales/${category.toLowerCase()}`

export interface TaleListRouteParamProps {
  readonly category: string
}
